<template>
  <div class="dashboard-page">
    <div class="dashboard-header">
      <h1>Insights</h1>
    </div>
    <DealerDashboard />
  </div>
</template>

<script setup lang="ts">
import DealerDashboard from '@/components/DealerDashboard.vue';
</script>

<style scoped>
.dashboard-page {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 65px);
  padding: 0 16px;
  padding-top: 65px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.dashboard-header h1 {
  font-size: 26px;
  font-weight: 600;
  color: #1C1C1E;
  margin: 0;
}
</style> 